// ABOUTME: PostHog browser-side instrumentation for error tracking
// ABOUTME: Configured for error tracking only — analytics/replay disabled to keep event volume in the free tier (1M events/mo)

import posthog from "posthog-js"

const apiKey = process.env.NEXT_PUBLIC_POSTHOG_KEY
// When set, route ingestion through our own domain via next.config.mjs
// rewrites — bypasses ad blockers without paying for a tunnel.
const apiHost = process.env.NEXT_PUBLIC_POSTHOG_HOST || "/ingest"

if (apiKey && process.env.NODE_ENV === "production") {
  posthog.init(apiKey, {
    api_host: apiHost,
    ui_host: "https://us.posthog.com",

    // We use Drafty's own analytics (/api/analytics + stats.drafty.com) for
    // product analytics. PostHog here is purely an error tracker, so opt
    // out of every event class that isn't an exception.
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: false,
    disable_session_recording: true,

    // Auto-capture unhandled errors and unhandled promise rejections.
    // PostHog wraps window.onerror and window.onunhandledrejection.
    capture_exceptions: true,

    // Don't ping the /decide endpoint for feature flags we don't use.
    advanced_disable_decide: true,

    // Drop noise that isn't actionable.
    before_send: (event) => {
      if (!event) return null
      const message = event.properties?.$exception_message as string | undefined
      if (typeof message === "string") {
        if (
          message.includes("ResizeObserver loop") ||
          message === "Non-Error promise rejection captured" ||
          message === "Failed to fetch" ||
          message === "Load failed" ||
          message.includes("NetworkError when attempting to fetch resource")
        ) {
          return null
        }
      }
      return event
    },

    persistence: "memory",
  })
}
